import { render, staticRenderFns } from "./Scorecard.vue?vue&type=template&id=08da2728&"
import script from "./Scorecard.vue?vue&type=script&lang=ts&"
export * from "./Scorecard.vue?vue&type=script&lang=ts&"
import style0 from "./Scorecard.vue?vue&type=style&index=0&id=08da2728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports